/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CustomerPositionMode } from '../models/CustomerPositionMode';
import type { CustomerTradingPairConfiguration } from '../models/CustomerTradingPairConfiguration';
import type { SetCustomerTradingPairLeverageRequest } from '../models/SetCustomerTradingPairLeverageRequest';
import type { SetCustomerTradingPairMarginModeRequest } from '../models/SetCustomerTradingPairMarginModeRequest';
import type { SetDerivativesPositionModeRequest } from '../models/SetDerivativesPositionModeRequest';
import type { CancelablePromise } from '../../../core/CancelablePromise';
import type { BaseHttpRequest } from '../../../core/BaseHttpRequest';
export class DerivativesCustomerConfigurationService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @returns CustomerPositionMode Success
     * @throws ApiError
     */
    public getV1DerivativesCustomerConfigurationPositionMode(): CancelablePromise<CustomerPositionMode> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/derivatives/customer-configuration/position-mode',
            errors: {
                404: `Not Found`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public putV1DerivativesCustomerConfigurationPositionMode(
        requestBody?: SetDerivativesPositionModeRequest,
    ): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/v1/derivatives/customer-configuration/position-mode',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
            },
        });
    }
    /**
     * @param code
     * @returns CustomerTradingPairConfiguration Success
     * @throws ApiError
     */
    public getV1DerivativesCustomerConfigurationTradingPairs(
        code: string,
    ): CancelablePromise<CustomerTradingPairConfiguration> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/derivatives/customer-configuration/trading-pairs/{code}',
            path: {
                'code': code,
            },
            errors: {
                404: `Not Found`,
            },
        });
    }
    /**
     * @param code
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public putV1DerivativesCustomerConfigurationTradingPairsLeverage(
        code: string,
        requestBody?: SetCustomerTradingPairLeverageRequest,
    ): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/v1/derivatives/customer-configuration/trading-pairs/{code}/leverage',
            path: {
                'code': code,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
            },
        });
    }
    /**
     * @param code
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public putV1DerivativesCustomerConfigurationTradingPairsMarginMode(
        code: string,
        requestBody?: SetCustomerTradingPairMarginModeRequest,
    ): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/v1/derivatives/customer-configuration/trading-pairs/{code}/margin-mode',
            path: {
                'code': code,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
            },
        });
    }
}
